import { fromJS } from 'immutable';
import {
  LOAD_PAYMENTS_SUCCESS,
  LOAD_PAYMENTS_ERROR,
} from './constants';

const initialState = fromJS({
  payments: {},
  paymentsLoading: true,
  paymentsError: null,
});

function paymentsReducer(state = initialState, action) {
  switch (action.type) {
  case LOAD_PAYMENTS_ERROR:
    return state
      .set('payments', null)
      .set('paymentsLoading', false)
      .set('paymentsError', action.error);
  case LOAD_PAYMENTS_SUCCESS:
    return state
      .set('payments', action.data)
      .set('paymentsLoading', false)
      .set('paymentsError', null);
  default:
    return state;
  }
}

export default paymentsReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/payments/reducer.js
 **/